import React from 'react';
import ClausesList from '@/components/Clause/MaintainClause';


const Clause = () => {
    return (
        <div className="h-full p-4">
           
                <ClausesList
                />
          

            
        </div>
    );
};

export default Clause;
